import { ACTION_SUBJECT_PREFIX } from '../../constants/analytics';
import { type FireAnalyticsEvent } from '../../types';
import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

export type SearchResultCount = {
	peopleAndTeams: number;
	autoSuggestion: number;
	recentSearch: number;
	recentViews: number;
};

type QueryDuration = {
	peopleAndTeams: number;
	autoSuggestion: number;
};

type onDropdownResultsShownArgs = {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
	count: SearchResultCount;
	duration: QueryDuration;
};

export const onDropdownResultsShown = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	count,
	duration,
}: onDropdownResultsShownArgs): FireAnalyticsEvent => ({
	eventType: 'track',
	actionSubject: `${ACTION_SUBJECT_PREFIX}DropdownResults`,
	action: 'shown',
	attributes: {
		additionalAttributes: {
			count,
			duration,
		},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
